import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '複数ベンダー分散によるボタンの掛け違いを解消すべく、情報設計からフロントエンド開発まで一気通貫で担当。デザインスプリントとユーザーインタビューを経てマイページをリニューアルし、ユーザー数の大幅増加を実現したコープ共済連の開発事例です。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/kyosaimypage/ogp_kyosaimypage.png'

export const kyosaimypagePageMeta: PageMeta = {
  title: 'コープ共済 マイページUX/UI刷新でユーザー数増加｜情報設計〜開発一気通貫の事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI フロントエンド開発 ヒューリスティック調査 情報設計 デザインスプリント',
  image: ogpImg,
  url: `${SITE_URL}/cases/kyosaimypage/`,
}

export const kyosaimypageSchema = buildCaseStudySchema({
  slug: 'kyosaimypage',
  pageTitle: kyosaimypagePageMeta.title,
  description: kyosaimypagePageMeta.description,
  headline: '共済マイページのユーザー数増加、リニューアル後も継続支援',
  alternativeHeadline: '日本コープ共済生活協同組合連合会',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/kyosaimypage/top.png'],
  clientName: '日本コープ共済生活協同組合連合会',
  breadcrumbLabel: '共済マイページのユーザー数増加、リニューアル後も継続支援',
})
